import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface EmptyStateProps {
  isFiltered?: boolean;
  onClearFilters?: () => void;
}

const EmptyState = ({ isFiltered = false, onClearFilters }: EmptyStateProps) => {
  if (isFiltered) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="FunnelIcon" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">
          No plans match your filters
        </h3>
        <p className="text-muted-foreground mb-6 max-w-md mx-auto">
          Try adjusting your search criteria or clearing the filters to see all your saved plans.
        </p>
        <button
          onClick={onClearFilters}
          className="inline-flex items-center space-x-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors duration-200"
        >
          <Icon name="XMarkIcon" size={16} />
          <span>Clear Filters</span>
        </button>
      </div>
    );
  }

  return (
    <div className="text-center py-12">
      <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon name="DocumentPlusIcon" size={32} className="text-primary" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">
        No saved plans yet
      </h3>
      <p className="text-muted-foreground mb-6 max-w-md mx-auto">
        Start creating your first space optimization plan to transform your outdoor area into a productive space.
      </p>
      <Link
        href="/input-form"
        className="inline-flex items-center space-x-2 px-6 py-3 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors duration-200"
      >
        <Icon name="PlusIcon" size={20} />
        <span>Create Your First Plan</span>
      </Link>
    </div>
  );
};

export default EmptyState;